import apiService from "./apiService";
import AppConstants from "../appConstants";

class AppConfigRulesService {
    getAllAppConfigRules(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_APP_CONFIG_RULES, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAppConfigRulesDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_APP_CONFIG_RULES}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerAppConfigRules(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_APP_CONFIG_RULES, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAppConfigRules(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_APP_CONFIG_RULES}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_APP_CONFIG_RULES_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new AppConfigRulesService();
